import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@app/environment/environment';
import {
  CompanyType,
  CreateCompanyType,
  CreateDatabaseManagement,
  DatabaseManagement,
} from '@app/models/admin.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MasterdataService {
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  //Company types:
  activateCompanyType(companyType: any, isActive: boolean): Observable<any> {
    return this.http.put(`${this.API_URL}/CompanyType/${companyType.id}`, {
      ...companyType,
      isActive,
    });
  }

  getCompanyTypeById(companyTypeId: string): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/CompanyType/${companyTypeId}`);
  }

  deleteCompanyTypeById(companyTypeId: string): Observable<any> {
    return this.http.delete<any>(
      `${this.API_URL}/CompanyType/${companyTypeId}`
    );
  }

  createCompanyType(payload: CreateCompanyType): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/CompanyType`, payload);
  }

  loadCompanyTypesCodeFiltered(filter: string): Observable<any> {
    const response = `${
      this.API_URL
    }/CompanyTypesAdmin?take=1000&sort=[{"selector":"Code","desc":false}]&filter${encodeURIComponent(
      filter
    )}`;

    return this.http.get<any>(response);
  }

  updateCompanyType(payload: CompanyType): Observable<any> {
    return this.http.put<any>(
      `${this.API_URL}/CompanyType/${payload.id}`,
      payload
    );
  }

  //Countries:
  activateCountry(country: any, isActive: boolean): Observable<any> {
    return this.http.put(`${this.API_URL}/Country/${country.id}`, {
      ...country,
      isActive,
    });
  }

  getCountryById(countryId: string): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/Country/${countryId}`);
  }

  deleteCountryById(countryId: string): Observable<any> {
    return this.http.delete<any>(`${this.API_URL}/Country/${countryId}`);
  }

  createCountry(payload: CreateDatabaseManagement): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/Country`, payload);
  }

  updateCountry(payload: DatabaseManagement): Observable<any> {
    return this.http.put<any>(`${this.API_URL}/Country/${payload.id}`, payload);
  }
  loadCountriesCodeFiltered(filter: string): Observable<any> {
    const response = `${
      this.API_URL
    }/CountriesAdmin?take=1000&sort=[{"selector":"Code","desc":false}]&filter${encodeURIComponent(
      filter
    )}`;

    return this.http.get<any>(response);
  }

  //Currencies:
  activateCurrency(currency: any, isActive: boolean): Observable<any> {
    return this.http.put(`${this.API_URL}/Currency/${currency.id}`, {
      ...currency,
      isActive,
    });
  }

  getCurrencyById(currencyId: string): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/Currency/${currencyId}`);
  }

  deleteCurrencyById(currencyId: string): Observable<any> {
    return this.http.delete<any>(`${this.API_URL}/Currency/${currencyId}`);
  }

  createCurrency(payload: CreateDatabaseManagement): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/Currency`, payload);
  }

  updateCurrency(payload: DatabaseManagement): Observable<any> {
    return this.http.put<any>(
      `${this.API_URL}/Currency/${payload.id}`,
      payload
    );
  }
  loadCurrenciesCodeFiltered(filter: string): Observable<any> {
    const response = `${
      this.API_URL
    }/CurrenciesAdmin?take=1000&sort=[{"selector":"Code","desc":false}]&filter${encodeURIComponent(
      filter
    )}`;

    return this.http.get<any>(response);
  }

  //Legal Entity Roles:
  activateLegalEntityRole(
    legalEntityRole: any,
    isActive: boolean
  ): Observable<any> {
    return this.http.put(
      `${this.API_URL}/LegalEntityRoles/${legalEntityRole.id}`,
      {
        ...legalEntityRole,
        isActive,
      }
    );
  }

  getLegalEntityRoleById(legalEntityRoleId: string): Observable<any> {
    return this.http.get<any>(
      `${this.API_URL}/LegalEntityRoles/${legalEntityRoleId}`
    );
  }

  deleteLegalEntityRoleById(legalEntityRoleId: string): Observable<any> {
    return this.http.delete<any>(
      `${this.API_URL}/LegalEntityRoles/${legalEntityRoleId}`
    );
  }

  createLegalEntityRole(payload: CreateDatabaseManagement): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/LegalEntityRoles`, payload);
  }

  updateLegalEntityRole(payload: DatabaseManagement): Observable<any> {
    return this.http.put<any>(
      `${this.API_URL}/LegalEntityRoles/${payload.id}`,
      payload
    );
  }

  loadLegalEntityRolesCodeFiltered(filter: string): Observable<any> {
    const response = `${
      this.API_URL
    }/LegalEntityRoleAdmin?take=1000&sort=[{"selector":"Code","desc":false}]&filter${encodeURIComponent(
      filter
    )}`;

    return this.http.get<any>(response);
  }

  //Name Titles:
  activateNameTitle(nameTitle: any, isActive: boolean): Observable<any> {
    return this.http.put(`${this.API_URL}/NameTitles/${nameTitle.id}`, {
      ...nameTitle,
      isActive,
    });
  }
  getNameTitleById(nameTitleId: string): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/NameTitles/${nameTitleId}`);
  }

  deleteNameTitleById(nameTitleId: string): Observable<any> {
    return this.http.delete<any>(`${this.API_URL}/NameTitles/${nameTitleId}`);
  }

  createNameTitle(payload: CreateDatabaseManagement): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/NameTitles`, payload);
  }

  updateNameTitle(payload: DatabaseManagement): Observable<any> {
    return this.http.put<any>(
      `${this.API_URL}/NameTitles/${payload.id}`,
      payload
    );
  }

  loadNameTitlesCodeFiltered(filter: string): Observable<any> {
    const response = `${
      this.API_URL
    }/NameTitleAdmin?take=1000&sort=[{"selector":"Code","desc":false}]&filter${encodeURIComponent(
      filter
    )}`;

    return this.http.get<any>(response);
  }

  //Person Roles:
  activatePersonRole(personRole: any, isActive: boolean): Observable<any> {
    return this.http.put(`${this.API_URL}/PersonRoles/${personRole.id}`, {
      ...personRole,
      isActive,
    });
  }
  getPersonRoleById(personRoleId: string): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/PersonRoles/${personRoleId}`);
  }

  deletePersonRoleById(personRoleId: string): Observable<any> {
    return this.http.delete<any>(`${this.API_URL}/PersonRoles/${personRoleId}`);
  }

  createPersonRole(payload: CreateDatabaseManagement): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/PersonRoles`, payload);
  }

  updatePersonRole(payload: DatabaseManagement): Observable<any> {
    return this.http.put<any>(
      `${this.API_URL}/PersonRoles/${payload.id}`,
      payload
    );
  }

  loadPersonRolesCodeFiltered(filter: string): Observable<any> {
    const response = `${
      this.API_URL
    }/PersonRoleAdmin?take=1000&sort=[{"selector":"Code","desc":false}]&filter${encodeURIComponent(
      filter
    )}`;

    return this.http.get<any>(response);
  }

  //Project Classifications:

  activateProjectClassification(
    projectClassification: any,
    isActive: boolean
  ): Observable<any> {
    return this.http.put(
      `${this.API_URL}/ProjectClassifications/${projectClassification.id}`,
      {
        ...projectClassification,
        isActive,
      }
    );
  }

  getProjectClassificationById(
    projectClassificationId: string
  ): Observable<any> {
    return this.http.get<any>(
      `${this.API_URL}/ProjectClassifications/${projectClassificationId}`
    );
  }

  deleteProjectClassificationById(
    projectClassificationId: string
  ): Observable<any> {
    return this.http.delete<any>(
      `${this.API_URL}/ProjectClassifications/${projectClassificationId}`
    );
  }

  createProjectClassification(
    payload: CreateDatabaseManagement
  ): Observable<any> {
    return this.http.post<any>(
      `${this.API_URL}/ProjectClassifications`,
      payload
    );
  }

  updateProjectClassification(payload: DatabaseManagement): Observable<any> {
    return this.http.put<any>(
      `${this.API_URL}/ProjectClassifications/${payload.id}`,
      payload
    );
  }

  loadProjectClassificationsCodeFiltered(filter: string): Observable<any> {
    const response = `${
      this.API_URL
    }/ProjectClassificationAdmin?take=1000&sort=[{"selector":"Code","desc":false}]&filter${encodeURIComponent(
      filter
    )}`;

    return this.http.get<any>(response);
  }
}
